<template>
  <md-dialog 
    :md-active.sync="showDialog" 
    class="new-med-dialog new-globals"
    @md-clicked-outside="clickOutside"
  >
    <md-dialog-content>
      <label>Add New Medication</label>
      <md-field 
        class="new-medication ui-theme-3 compact"
      >
        <md-input 
          :value="isNewDosage ? group.label.en : state.name"
          :disabled="isNewDosage"
          placeholder="Enter a name"
          @input="updateName"
        />
      </md-field>
      <md-divider class="divider" />
      <label>Add New Dosage Form</label>
      <md-field class="ui-theme-3 dosage-form compact">
        <md-select
          :value="state.dosageFormType"
          @input="updateDosageFormType"
        >
          <md-option
            v-for="df in dosageForms"
            :key="df.key"
            :value="df.key"
          >
            {{ df.label.en }}
          </md-option>
        </md-select>
      </md-field>
      <concentration
        :dosage-form-type="state.dosageFormType"
        :concentration="state.concentration"
        @update="updateConcentration"
      />
    </md-dialog-content>
    <md-dialog-actions>
      <md-button 
        class="cancel-button"
        @click="cancel"
      >
        Cancel
      </md-button>
      <md-button 
        class="md-outlined-button submit-button" 
        :disabled="!hasCompleteInput"
        @click="submit"
      >
        Submit
      </md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import { dosageForms } from '~lib/common/config/medication';

import Concentration from './Concentration';

export default {
  name: 'new-med-dialog',
  components: {
    Concentration,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    group: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      showDialog: false,
      state: {
        name: null,
        dosageFormType: null,
        concentration: null,
      },
      dosageForms,
    };
  },
  computed: {
    hasCompleteInput() {
      let hasComplete = true;      
      if (!this.isNewDosage && !this.state.name) {
        hasComplete = false;
      }
      if (!this.state.dosageFormType) {
        hasComplete = false;
      }
      if (!this.hasCompleteConcentration(this.state.dosageFormType, this.state.concentration)) {
        hasComplete = false;
      }      
      return hasComplete;
    },
    isNewDosage() {
      return !!this.group;
    },
  },
  watch: {
    show(value) {
      this.showDialog = value;
    }
  },
  created() {
    this.reset();
  },
  methods: {
    updateName(value) {
      this.state.name = value;
    },
    cancel() {
      this.state.showDialog = false;
      this.$emit('cancel');
      this.reset();
    },
    submit() {
      this.state.showDialog = false;
      if (this.isNewDosage) {
        this.$emit('submit', {
          dosageFormType: this.state.dosageFormType,
          concentration: this.state.concentration
        });
      } else {
        this.$emit('submit', {
          name: this.state.name,
          dosageFormType: this.state.dosageFormType,
          concentration: this.state.concentration
        });
      }
      this.reset();
    },
    clickOutside() {
      this.cancel();
    },
    reset() {
      this.state.name = 'New Medication';
      this.state.dosageFormType = dosageForms[0].key;
      this.state.concentration = {
        numeratorValue: null,
        numeratorUnits: null,
        denominatorValue: null,
        denominatorUnits: null,
      };
    },
    updateDosageFormType(value) {
      this.state.dosageFormType = value;
    },
    updateConcentration(value) {
      this.state.concentration = value;
    },
    hasCompleteConcentration(dosageFormType, conc) {
      const df = dosageForms.find(df => df.key === dosageFormType);
      return conc.numeratorValue && conc.numeratorValue > 0 && conc.numeratorUnits && 
        (!df.unitCategories2 || (conc.denominatorValue && conc.denominatorUnits));
    }
  }
}
</script>

<style scoped>
.new-med-dialog {
  height: auto;
  min-width: 500px;
}

.md-field.compact {
  margin: 0 !important;
  margin-top: 12px !important;
  padding-top: 6px !important;
  padding-bottom: 0 !important;
  min-height: 40px;
}

.divider {
  margin: 1rem 0;
}

.concentration {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.submit-button {
  color: white;
  background-color: #3277CC;
}
</style>